import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { userActions } from '../../store/modules/user';

const useResendConfirmEmailHandler = () => {
  const dispatch = useDispatch();
  const handler = useCallback(
    () => dispatch(userActions.resendConfirmEmail()),
    []
  );

  return handler;
};

export default useResendConfirmEmailHandler;
